// Staff policy is independent of the shorter WebTrader password policy.
const GROUPS = ['ABCDEFGHJKLMNPQRSTUVWXYZ', 'abcdefghijkmnopqrstuvwxyz', '23456789', '!@#$%^&*()-_=+[]{}:,.?/'];

const randomIndex = length => {
  if (!globalThis.crypto?.getRandomValues) throw new Error('Secure randomness unavailable');
  const byte = new Uint8Array(1);
  const limit = 256 - (256 % length);
  do { globalThis.crypto.getRandomValues(byte); } while (byte[0] >= limit);
  return byte[0] % length;
};

export const generateStaffPassword = () => {
  const chars = GROUPS.map(group => group[randomIndex(group.length)]);
  const alphabet = GROUPS.join('');
  while (chars.length < 16) chars.push(alphabet[randomIndex(alphabet.length)]);
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
};